import * as React from 'react';
import { InlineText1 } from '@cian/ui-kit';
import { IRooms } from '../../containers/RoomsList/types';
import * as styles from './RoomsList.css';

interface IRoomsListProps {
  rooms: IRooms[];
}

export function RoomsList({ rooms }: IRoomsListProps) {
  return (
    <ul className={styles['rooms']}>
      {rooms.map((room, index) => {
        return (
          <li className={styles['rooms__item']} key={index}>
            <InlineText1>{room.roomsCount}</InlineText1>
            <InlineText1 fontWeight="bold">{room.minPrice}</InlineText1>
          </li>
        );
      })}
    </ul>
  );
}
